"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Accordion = _interopRequireDefault(require("@commerce-ui/core2/Accordion"));
var _ShowHide = _interopRequireDefault(require("@commerce-ui/core2/ShowHide"));
var _Button = _interopRequireDefault(require("@commerce-ui/core2/Button"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PlusIcon = function PlusIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 19.338v-13h1.2v13h-1.2z"
  }));
};
PlusIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusIcon = function MinusIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 13.438h-13v-1.2h13v1.2z"
  }));
};
MinusIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlusIconLarge = function PlusIconLarge(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M18.224 9.14v18.283m-9.083-9.484h18.281",
    stroke: "#000",
    strokeWidth: "1.523"
  }));
};
PlusIconLarge.defaultProps = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusIconLarge = function MinusIconLarge(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M9.14 18.282h18.282",
    stroke: "#000",
    strokeWidth: "1.523"
  }));
};
MinusIconLarge.defaultProps = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  initialOpen: false,
  isLastElement: false,
  buttonPadding: {
    pt: 17,
    pb: 13
  },
  largerIcons: false
};
var FaqRaw = function FaqRaw(props) {
  var question = props.question,
    answer = props.answer,
    _props$initialOpen = props.initialOpen,
    initialOpen = _props$initialOpen === void 0 ? defaultProps.initialOpen : _props$initialOpen,
    labelFont = props.labelFont,
    textFont = props.textFont,
    _props$isLastElement = props.isLastElement,
    isLastElement = _props$isLastElement === void 0 ? defaultProps.isLastElement : _props$isLastElement,
    _props$buttonPadding = props.buttonPadding,
    buttonPadding = _props$buttonPadding === void 0 ? defaultProps.buttonPadding : _props$buttonPadding,
    _props$largerIcons = props.largerIcons,
    largerIcons = _props$largerIcons === void 0 ? defaultProps.largerIcons : _props$largerIcons;
  var plusIcon = largerIcons ? __jsx(PlusIconLarge, null) : __jsx(PlusIcon, null);
  var minusIcon = largerIcons ? __jsx(MinusIconLarge, null) : __jsx(MinusIcon, null);
  return __jsx(_Accordion["default"], {
    sx: {
      minWidth: "100%"
    }
  }, __jsx(_Accordion["default"].Section, {
    isOpenAtInit: initialOpen
  }, __jsx(_Button["default"], {
    sx: _objectSpread(_objectSpread({
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }, buttonPadding), {}, {
      width: "100%",
      color: "main",
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      }
    })
  }, function (_ref) {
    var selected = _ref.selected;
    return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
      sx: {
        font: labelFont ? labelFont : "base_sans_bold",
        maxWidth: "calc(100% - 24px)"
      }
    }, question), __jsx(_Box["default"], null, selected ? minusIcon : plusIcon));
  }), __jsx(_ShowHide["default"], null, __jsx(_Box["default"], {
    sx: {
      p: "16px 0px",
      pt: 0,
      font: textFont ? textFont : "body",
      color: "main"
    }
  }, answer.map(function (answerParagraph, index) {
    return __jsx(_Box["default"], {
      key: "answerParagraph-".concat(index),
      dangerouslySetInnerHTML: {
        __html: answerParagraph.text
      }
    });
  })))), !isLastElement && __jsx(_Box["default"], {
    sx: {
      height: "1px",
      bg: "neutral"
    }
  }));
};
var _default = FaqRaw;
exports["default"] = _default;